import React from 'react'
import {ToastContainer } from 'react-toastify';
import Spinner from '../Spinner/spinner';
import UseAddPromotionalAddOn from './Hooks/useAddPromotionalAddOn';


const AddPromotionalAddOn = () => {
    const {spinner,messagePlanAdd}=UseAddPromotionalAddOn()
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Add Promotional Message Plan
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={messagePlanAdd.handleSubmit}>

                        <div className="d-flex gap-2">
                            <div className="col-md-6">
                                <label htmlFor="recipient-name" className="col-form-label">Name *</label>
                                <input type="text" className="form-control"
                                    id="recipient-name"
                                    name='planName'
                                    onChange={messagePlanAdd.handleChange}
                                    value={messagePlanAdd.values.planName}
                                />
                                {messagePlanAdd.touched.planName && messagePlanAdd.errors.planName ? (
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                        {messagePlanAdd.errors.planName}
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="recipient-name" className="col-form-label">Price *</label>
                                <input type="Number" className="form-control"
                                    id="recipient-name"
                                    name='price'
                                    onChange={messagePlanAdd.handleChange}
                                    value={messagePlanAdd.values.price}
                                />
                                {messagePlanAdd.touched.price && messagePlanAdd.errors.price ? (
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                        {messagePlanAdd.errors.price}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="d-flex gap-2">
                            <div className="col-md-6">
                                <label htmlFor="recipient-name" className="col-form-label">Credit *</label>
                                <input type="Number" className="form-control"
                                    id="recipient-name"
                                    name='credit'
                                    onChange={messagePlanAdd.handleChange}
                                    value={messagePlanAdd.values.credit}
                                />
                                {messagePlanAdd.touched.credit && messagePlanAdd.errors.credit ? (
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                        {messagePlanAdd.errors.credit}
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-md-6 ">
                                <label htmlFor="recipient-name" className="col-form-label">Description *</label>
                                <textarea
                                    className="form-control"
                                    id="recipient-name"
                                    name="description"
                                    rows="4"
                                    onChange={messagePlanAdd.handleChange}
                                    value={messagePlanAdd.values.description}
                                />
                                {messagePlanAdd.touched.description && messagePlanAdd.errors.description ? (
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                        {messagePlanAdd.errors.description}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        
                         
                        








                        <p>* Note : Please fill all the mandatory fields</p>
                        < div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default AddPromotionalAddOn